/*
Description: This file contains the code for the templae row name component. This component 
    is used to display the conversation name and group name in the conversation table.
Author: Jake Michalski
Date: 12/3/2023
*/

import React from 'react';
import { getEmrNoteTypesLabel } from './utils';

function getBaseUrl(template_emr_url) {
  return template_emr_url
    ? template_emr_url
        .replace(/(https?:\/\/)?(www\.)?(.+\..+)(\/)?(.com)?/i, '$3')
        .replace('.com', '')
    : null;
}

export const TemplateRowName = ({ template }) => {
  let templateURL = getBaseUrl(template.emr_url);
  const noteTypesLabel = getEmrNoteTypesLabel(
    template,
    'No EMR note types matched',
  );
  if (templateURL && templateURL.includes('appprehendpt')) {
    templateURL = null;
  }

  const marginTopVal = templateURL ? '-1rem' : '0';
  return (
    <th scope="row">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ color: '#535f7f', fontWeight: 600 }}>
          {template.name}
        </span>
        {template.sharedAccess &&
          Object.keys(template.sharedAccess).length > 0 && (
            <i className="fa fa-users ml-2" style={{ color: '#6c757d' }}></i> // Adjust color here
          )}
      </div>
      {templateURL && (
        <div
          style={{
            fontWeight: 'normal',
            fontSize: '0.8rem',
            marginTop: '0.2rem',
            color: '#6c757d', // Set color here
          }}
        >
          {templateURL} {' - '} {noteTypesLabel}
        </div>
      )}
    </th>
  );
};

export const SharedTemplateRowName = ({ template }) => {
  // console.log(template);
  template.name = template.sharedConfigName;
  return <TemplateRowName template={template} />;
};
